import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { ICheckmarkItem } from '../../../shared/components/checkmark-list/checkmark-list.component';

@Injectable()
export class OnboardingStripeDialogBuilder {
  constructor(private _translateService: TranslateService) {}

  buildListItems(): List<ICheckmarkItem> {
    return List([
      {
        value: this._translateService.instant(
          'DIALOG.PAYMENTS.ITEM.MAKE_IT_EASY_TO_PAY'
        ),
      },
      {
        value: this._translateService.instant(
          'DIALOG.PAYMENTS.ITEM.ACCEPT_PAYMENT_ONLINE'
        ),
      },
      {
        value: this._translateService.instant(
          'DIALOG.PAYMENTS.ITEM.FAST_EASY_SETUP'
        ),
      },
    ]);
  }
}
